import { t } from 'lib/i18n'

import { SystemMessage } from './SystemMessage'

export const ServerErrorPage = () => (
  <SystemMessage
    icon="alert"
    code="500"
    title={t('حدث خطأ غير متوقع', 'Something went wrong')}
    description={t(
      'واجه التطبيق خطأ ولم يتمكن من إكمال الصفحة. حاول إعادة تحميل الصفحة، وإن استمرت المشكلة تواصل مع الدعم الفني.',
      'The app hit an error and could not finish this page. Reload the page, and contact support if it keeps happening.'
    )}
    actions={
      <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
        {t('إعادة التحميل', 'Reload')}
      </button>
    }
  />
)
